import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const BrandingContext = createContext(null);

const DEFAULTS = {
  app_name: 'FPS OS',
  sidebar_logo: null,
  login_logo: null,
  favicon: null,
  login_prompt: 'Sign in with your corporate account\n@frontporchsolutions.com',
  login_footer_note: 'Only @frontporchsolutions.com accounts can access',
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const fetchBranding = useCallback(async () => {
    try {
      const res = await fetch('/api/admin/branding');
      if (res.ok) {
        const data = await res.json();
        setBranding(prev => ({ ...prev, ...data.branding }));
      }
    } catch {
      // Use defaults on error
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchBranding();
  }, [fetchBranding]);

  // Apply favicon dynamically when branding changes
  useEffect(() => {
    if (branding.favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = branding.favicon;
    }
  }, [branding.favicon]);

  // Update page title with app name
  useEffect(() => {
    if (branding.app_name) {
      document.title = branding.app_name;
    }
  }, [branding.app_name]);

  const value = { branding, loaded, refetch: fetchBranding, defaults: DEFAULTS };

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
}
